import axios from "axios";

function   uploadFiles (path,params) {
  return axios.post(path, params,
    // { headers: { 'Content-Type': 'multipart/form-data', token: window.localStorage.getItem('token')}})
    { headers: { 'Content-Type': 'multipart/form-data'}})
}

export default {
  uploadFiles
}



// WEBPACK FOOTER //
// ./src/utils/utils.js